import * as React from "react"

const SvgRss = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.429q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 19.43q0-.825.587-1.413A1.93 1.93 0 0 1 5 17.43q.824 0 1.412.587Q7 18.605 7 19.43c0 .825-.196 1.02-.588 1.412A1.93 1.93 0 0 1 5 21.43Zm13.5 0q-.65 0-1.087-.475a1.95 1.95 0 0 1-.513-1.125 13.7 13.7 0 0 0-1.312-4.538A14 14 0 0 0 12.9 11.53a14 14 0 0 0-3.763-2.69A13.7 13.7 0 0 0 4.6 7.53a1.95 1.95 0 0 1-1.125-.513A1.42 1.42 0 0 1 3 5.93q0-.65.45-1.063a1.36 1.36 0 0 1 1.075-.362q3.075.275 5.762 1.562a17 17 0 0 1 4.738 3.338 17.1 17.1 0 0 1 3.338 4.737 16.7 16.7 0 0 1 1.562 5.763q.05.625-.363 1.075-.412.45-1.062.45Zm-6 0q-.625 0-1.075-.438a2 2 0 0 1-.575-1.062 7.6 7.6 0 0 0-.787-2.263A8.2 8.2 0 0 0 8.65 15.78a8.2 8.2 0 0 0-1.888-1.413A7.6 7.6 0 0 0 4.5 13.58a2 2 0 0 1-1.063-.575A1.49 1.49 0 0 1 3 11.929q0-.65.45-1.075.45-.426 1.075-.325 1.825.249 3.412 1.062a11.2 11.2 0 0 1 4.9 4.9 10.6 10.6 0 0 1 1.063 3.413 1.21 1.21 0 0 1-.325 1.075q-.425.45-1.075.45" />
  </svg>
)
export default SvgRss
